import Cookies from 'js-cookie'

const TokenKey = 'accessToken'
const TokenKey1 = 'refreshToken'
export function getToken() {
  return Cookies.get(TokenKey)
  // return 'rwerf'
}
export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function getRefreshToken() {
  return Cookies.get(TokenKey1)
}
export function setRefreshToken(token) {
  return Cookies.set(TokenKey1, token)
}
export function removeRefreshToken() {
  return Cookies.remove(TokenKey1)
}

export function getTenantId() {
  return Cookies.get("tenantId")
}
export function setTenantId(tenantId) {
  return Cookies.set("tenantId", tenantId)
}
export function removeTenantId() {
  return Cookies.remove("tenantId")
}